import { Header } from '../../../components/header';
import { useTranslation } from 'react-i18next';
import { useState, useMemo } from 'react';
import Sidebar from '../../../components/Sidebar';
import TimesheetTabs from './components/TimesheetTabs';
import TimesheetCreation from './components/TimesheetCreation';
import TimesheetReports from './components/TimesheetReports';
import WorkedHours from './components/WorkedHours';
import './timeSheetsPage.scss';
import { INVOZIO_BLOB_BASE } from '../../../constant/video-url-import.constant';

const videoUrlEn = `${INVOZIO_BLOB_BASE}/how_to_use_timesheet_en.mp4`
const videoUrlSv = `${INVOZIO_BLOB_BASE}/how_to_use_timesheet_sv.mp4`
const tutorialIcon = <svg width={20} height={20} viewBox="0 0 100 85" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="100" height="70" fill="#6A5ACD" />
    <rect x="8" y="8" width="84" height="54" fill="#6A5ACD" />
    <path d="M42 25V45L58 35L42 25Z" fill="#FFFFFF" />
    <rect y="70" width="100" height="5" fill="#ffffff" />
    <rect y="75" width="100" height="10" fill="#6A5ACD" />
</svg>;

function TimeSheetsPage() {
    const { t } = useTranslation();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [activeTab, setActiveTab] = useState('creating-timesheet');
     const lang = new URLSearchParams(window.location.search).get('lang') || 'en-us';
    const isSv = lang === 'en-us' ? false : true
    const handleButtonClick=() =>{
      window.open(isSv ? videoUrlSv : videoUrlEn, '_blank', 'noopener,noreferrer');
    }

    const tabs = useMemo(() => [
        { key: 'creating-timesheet', label: t('CREATING_TIMESHEET') },
        { key: 'reports', label: t('REPORTS') },
        { key: 'worked-hours', label: t('WORKED_HOURS') }
    ], [t]);

    const renderContent = useMemo(() => {
        switch (activeTab) {
            case 'creating-timesheet':
                return <TimesheetCreation />;
            case 'reports':
                return <TimesheetReports />;
            case 'worked-hours':
                return <WorkedHours />;
            default:
                return <TimesheetCreation />;
        }
    }, [activeTab]);

    return (
        <div className="dashboard-page">
            <div className="dashboard-layout">
                <Sidebar
                    activeItemId='timesheets-invoice'
                    footer={null}
                    onClose={() => setIsSidebarOpen(false)}
                    className={`dashboard-sidebar ${isSidebarOpen ? 'sidebar-open' : ''}`}
                />
                <div className="dashboard-main-content">
                    <Header
                        setIsSidebarOpen={setIsSidebarOpen}
                    />
                    <div className='timesheet-page-container'>
                         <div className='timesheets-page-header'>
                            <button className="timesheets-page-header__button" onClick={()=>handleButtonClick()}>
                                <div>{tutorialIcon}</div>
                                <div>{t('timeSheetBtnTutorial')}</div>
                            </button>
                        </div>
                        <TimesheetTabs 
                            tabs={tabs}
                            activeTab={activeTab}
                            onTabChange={setActiveTab}
                        />
                        <div className='timesheet-content'>
                            {renderContent}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TimeSheetsPage;
